import { render, staticRenderFns } from "./approve-opinion.vue?vue&type=template&id=29fb16a4&scoped=true&"
import script from "./approve-opinion.vue?vue&type=script&lang=ts&"
export * from "./approve-opinion.vue?vue&type=script&lang=ts&"
import style0 from "./approve-opinion.vue?vue&type=style&index=0&id=29fb16a4&prod&lang=less&"
import style1 from "./approve-opinion.vue?vue&type=style&index=1&id=29fb16a4&prod&lang=less&scoped=true&"
import style2 from "./approve-opinion.vue?vue&type=style&index=2&id=29fb16a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb16a4",
  null
  
)

export default component.exports